import React from "react";
import { logGreyError } from "owa-analytics";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

/**
 * Context for the WorkPlansDailyPeek component. This type may be expanded and used for properties
 * that would otherwise be plumbed through multiple layers of components.
 */
export type WorkPlansDailyPeekContextType = {
    onSeeMoreClicked: ((url: string) => void) | undefined;
};

const defaultWorkPlansDailyPeekContextValue: WorkPlansDailyPeekContextType = {
    onSeeMoreClicked: undefined,
};

export const WorkPlansDailyPeekContext: React.Context<WorkPlansDailyPeekContextType | null> = React.createContext<WorkPlansDailyPeekContextType | null>(defaultWorkPlansDailyPeekContextValue);

export const useWorkPlansDailyPeekContextProvider = (): WorkPlansDailyPeekContextType | null => {
    const context = React.useContext(WorkPlansDailyPeekContext);
    
    if (context === undefined) {
        logGreyError("WorkPlansDailyPeek_ContextProvider_Error", getModuleContextMailboxInfo());
        return defaultWorkPlansDailyPeekContextValue;
    }
    else {
        return context;
    }
};
